<template>
  <div class="links-list pt-xl">
    <h5 v-if="children.length"  class="text-blue-4"
      v-text="localize(`${title}`) + ':'"
    ></h5>
    <a
      v-for="(link, index) in children"
      :key="link.title + index"
      @[__event(link)].prevent="mediaClickHandler(link)"
      :href="isMedia(link) ? '#p' : parseExternalUrl(link)"
      :target="windowTarget(link)"
    >
      <i :class="[link.icon || parseIcon(link)]"></i>
      <span v-text="link.title"></span>
      </a>
    <product-form v-if="cid === 3418"></product-form>
  </div>
</template>
<script>
import ProductForm from "@/components/ProductForm.vue";
import { sameDomain, notPDF } from "@/utils";

import { mapState, mapActions } from "vuex";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },    
    title: {
      type: String,
      default: "Learn more"
    }
  },
  mounted() {
    // console.log("MEDIA CHILDREN > ", this.localMediaChildren);
    this.setlocalMediaChildrenToGallery();
  },
  // data() {
  //   return {
  //     sameDomain,
  //     notPDF
  //   }
  // },
  components: {
    ProductForm
  },
  methods: {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    parseIcon(link) {

      var isVideoLink = false;
      var hasExt = false;
      //if (/(vimeo||youtube)/.test(link.url)){
        //isVideoLink=true;        
      //}
      if (link.url.indexOf("vimeo") > -1 || link.url.indexOf("youtube") > -1) {
        isVideoLink=true;        
      }
      if (link.url.indexOf(".") > -1) {
          hasExt=true;
      } 

      if (link.url.indexOf("pdf") > -1) {
          return "fal fa-file-pdf";
      } 
      else 
      {
          if(!isVideoLink){
            return "fas fa-link";
          }else{
            return "fal fa-video";
          }
      }      
      return "fa fa-angle-right";
    },
    setlocalMediaChildrenToGallery() {
      this.$nextTick(function() {
        //alert("children.length="+this.localMediaChildren.length);

        if (this.localMediaChildren && this.localMediaChildren.length) {
          this.setGalleryChildren(this.localMediaChildren);
        }
      });
    },
    clickHandler(item) {
      if (this.isMedia(item)) {
        let id = item.id,
          index = _.findIndex(this.mediaChildren, { id });
        console.log("ITEM > ", item);
        this.setGalleryIndex(index);
      } else if (this.isPDF(item)) {
        window.open(this.$fileFolder + item.url, "_blank");
      } else if (this.isExternalLink(item)) {
        window.open(item.url, "_blank");
      } else {
        this.$router.push(item.url);
      }
    },
    mediaClickHandler(item) {
      let id = item.id,
        index = _.findIndex(this.mediaChildren, { id });
      this.setGalleryIndex(index);
    },
    parseExternalUrl(item) {
      let isExternal = this.isExternalLink(item);
      if (isExternal) {
        return item.url;
      }
      if (this.isPDF(item)) {
        if (isExternal) {
          return item.url;
        } else {
          return this.$fileFolder + item.url;
        }
      }
    },
    isMedia(item) {
      return item.url && /(vimeo|youtube)/g.test(item.url);
    },
    isExternalLink(item) {
      return (
        /http/.test(item.url) || !sameDomain(item.url) || !notPDF(item.url)
      );
    },
    windowTarget(item) {
      if (this.isExternalLink(item) || this.isPDF(item)) {
        return "_blank";
      }
      return "_self";
    },
    __event(item) {
      return item.url && this.isMedia(item) ? "click" : null;
    },
    isPDF(item) {
      return sameDomain(item.url) && !notPDF(item.url);
    }
  },
  computed: {
    ...mapState({
      mediaChildren: state => state.gallery.children,
      cid: state => state.pageCid
    }),

    localMediaChildren() {
      return _.filter(
        this.children,
        child => child.url && /(vimeo|youtube)/g.test(child.url)
      );
    }
  }
};
</script>
<style lang="stylus">
.links-list
  h5
    margin-bottom 20px
  a
    cursor pointer
    display block
    text-align left
    _flex(row, nowrap, baseline, flex-start)
    margin-bottom 10px
    &:last-child
      margin-bottom 0
    span
      color gray_8
    i
      color gray_6
      // width 26px
      display inline-block
      text-align center
      margin-right 6px
    &:hover
      span
      i
        color blue_5
  +below(816px)
    h5
      margin-bottom 10px
    a
      margin-bottom 5px
      &:last-child
        margin-bottom 0
</style>
